<template>
  <v-row no-gutters>
    <v-col>
      <template v-if="canUserAccessRemoteLog">
        <monitor-view />
      </template>

      <template v-else>
        <user-view />
      </template>
    </v-col>
  </v-row>
</template>

<script>
import PermissionsMixin from '@/mixins/permissions'
const MonitorView = () =>
  import(/* webpackChunkName: "home-monitor-view" */ './MonitorView.vue')
const UserView = () =>
  import(/* webpackChunkName: "home-user-view" */ './UserView.vue')

export default {
  mixins: [PermissionsMixin],
  components: {
    MonitorView,
    UserView
  },
  created: async function () {
    await this.$store.dispatch('warning/load')
  }
}
</script>
